<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { SwitchRoot, SwitchThumb } from 'reka-ui';
import { cn } from '@/lib/utils';

defineOptions({ inheritAttrs: false });

const props = defineProps<{
    modelValue?: boolean;
    defaultValue?: boolean;
    disabled?: boolean;
    class?: HTMLAttributes['class'];
}>();

const emit = defineEmits<{
    'update:modelValue': [value: boolean];
}>();
</script>

<template>
    <SwitchRoot
        :model-value="props.modelValue"
        :default-value="props.defaultValue"
        :disabled="props.disabled"
        v-bind="$attrs"
        :class="cn(
            'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
            'disabled:cursor-not-allowed disabled:opacity-50',
            'data-[state=checked]:bg-nv-indigo data-[state=unchecked]:bg-input',
            props.class,
        )"
        @update:model-value="emit('update:modelValue', $event)"
    >
        <SwitchThumb
            :class="cn(
                'pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform',
                'data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0',
            )"
        />
    </SwitchRoot>
</template>
